import * as Math from './Math';

export { Math };
